import { Component, Input } from '@angular/core';
import {TableModule} from 'primeng/table';
import { NgForOf, NgIf} from '@angular/common';
import { PopoverModule } from 'primeng/popover';




@Component({
  selector: 'app-plugins-details',
  standalone: true,
  imports: [TableModule,PopoverModule, NgForOf, NgIf],
  templateUrl: './plugins-details.component.html',
  styleUrl: './plugins-details.component.css'
})
export class PluginsDetailsComponent {
  @Input() pluginsData: any[] = [];
  trackByIndex(index: number, item: any): number {
    return index;
  }

  pluginCount() {
    if(this.pluginsData === undefined) {
      return 0;
    }
    return this.pluginsData.length;
  }
}
